import { DEVICE } from "./config";

export const FEATURE_FLAGS = {
    ...(DEVICE === 'WEB' || DEVICE === 'PWA' ? {
        'sound-notifications': {
            title: t => t('Sound notifications'),
            description: t => t('This feature allows you to receive sound effects when you get a new notification or private message.'),
        },
    } : {}),
    'audio-library': {
        title: t => t('Audio Library'),
        description: t => t('This feature gives you access to the future Brickfilms.com audio library.'),
    },
    'download': {
        title: t => t('Download brickfilms'),
        description: t => t('This feature allows you to download brickfilms to watch them offline.'),
        isPremiumRequired: true,
        isForced: true,
    },
    'bimcomments': {
        title: t => t('Bricks in Motion comments'),
        description: t => t('This feature allows you to view comments published on Bricks in Motion on the brickfilm page; they are available in the "External comments" tab.'),
        isPremiumRequired: true,
        isForced: true,
    },
    'bbcomments': {
        title: t => t('Brickboard comments'),
        description: t => t('This feature allows you to view comments published on Brickboard on the brickfilm page; they are available in the "External comments" tab.'),
        isPremiumRequired: true,
        isForced: true,
    },
}